export default {
  endPoint: window.endPoint, // Production
  imageServer: window.imageServer,
  mormanServer: window.mormanServer,
  mormanReact: window.mormanReact,
  errorLink: window.errorLink,
  apiUpload: window.apiUpload,
  apiViewUpload: window.apiViewUpload,
  apiChoThongTinVay: window.apiChoThongTinVay,
  apiWebMorman: window.apiWebMorman,
};
